import { Grid, InputAdornment, TextField } from '@mui/material';
import { useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import WebIcon from '@mui/icons-material/Web';
import get from 'lodash.get';
import { PlayerForm } from './PlayerForm';

export function AllowedDomain({ index, remove }: { index: number; remove: (index: number) => void }) {
  const { register, formState } = useFormContext<PlayerForm>();
  const handleDelete = (index: number) => {
    return () => {
      remove(index);
    };
  };
  const errors: any = formState.errors;
  const { ref, onChange, onBlur, name } = register(`allowedDomains.${index}` as `allowedDomains.0`);
  const error = get(errors, name);
  return (
    <Grid item xs={12}>
      <TextField
        fullWidth
        variant="standard"
        error={!!error}
        label="Allowed domain"
        inputRef={ref}
        name={name}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <WebIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end" onClick={handleDelete(index)} style={{ cursor: 'pointer' }}>
              <RemoveCircleIcon />
            </InputAdornment>
          ),
        }}
        onChange={onChange}
        onBlur={(evt) => {
          if (evt.target.value == '') remove(index);
          else onBlur(evt);
        }}
        helperText={error ? error.message : null}
      />
    </Grid>
  );
}

function NewDomains({ append }: { append: any }) {
  const [isDirty, setDirty] = useState(false);
  const [current, setCurrent] = useState(0);
  const handleChange = (evt: any) => {
    setDirty(!!evt.target.value);
  };
  const handleBlur = (evt: any) => {
    if (evt.target.value) {
      append(evt.target.value);
      setCurrent((v) => (v == 0 ? 1 : 0));
    }
    evt.target.value = '';
    setDirty(false);
  };
  const createInput = (index: number) => {
    return (
      (isDirty || current == index) && (
        <Grid key={index} item xs={12}>
          <TextField
            fullWidth
            variant="standard"
            label="Allowed domain"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <WebIcon />
                </InputAdornment>
              ),
            }}
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={((isDirty && current != index) || !isDirty) && 'Enter domain allowed to show player'}
          />
        </Grid>
      )
    );
  };
  const inputs = [0, 1];
  if (current == 1) inputs.reverse();
  return <>{inputs.map((index) => createInput(index))}</>;
}

export default function AllowedDomains() {
  const {
    field: { value, onChange },
  } = useController({ name: 'allowedDomains' });
  const remove = (index: number) => {
    onChange(value.filter((email: string, _index: number) => index != _index));
  };
  const append = (email: string) => {
    onChange([...value, email]);
  };

  return (
    <>
      {[...value].map((domain: string, index: number) => (
        <AllowedDomain key={index} index={index} remove={remove} />
      ))}
      <NewDomains append={append} />
    </>
  );
}
